/* tslint:disable */
export enum Order {Asc = "asc",Desc = "desc"}
